import {FormControl, FormField} from 'platform/components';
import {Box, Integer} from 'platform/foundation';

import {FieldPathByValue, useWatch} from 'react-hook-form';

import {Nullish} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface PageItemTextInputProps {
  isReadOnly?: boolean;
  index: number;
  isCollapsed: boolean;
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  name: FieldPathByValue<DeliveryNoteDocumentPreviewFormDefinition, string | Nullish>;
  width: Integer;
  onChange?: (fieldName: string, value: string | null) => Promise<void>;
}

export function PageItemTextInput(props: PageItemTextInputProps) {
  const [value, isActive] = useWatch({
    control: props.control,
    name: [props.name, `listOfItems.${props.index}.isActive`],
  });

  return (
    <Box paddingHorizontal={2} paddingVertical={2} width={props.isCollapsed ? '100%' : props.width}>
      <FormField
        isAutoselectedOnFocus
        isDisabled={props.isReadOnly || !props.isConfirmed || !isActive}
        isInvalid={props.isConfirmed && isActive && !value}
        control={props.control}
        type="text"
        name={props.name}
        onChange={(value) => props.onChange?.(props.name, value)}
      />
    </Box>
  );
}
